<div
  echarts
  [theme]="theme"
  [options]="chartOptions"
  class="w-full {{ heightClass }}"
></div>
